import { gql } from '@apollo/client';

export const EXPORT_FUNDER_TEST_PERFORMANCE = gql`
  query ExportFunderTestPerformance($input: ExportArgs!) {
    exportFunderTestPerformance(input: $input) {
      id
      name
      class
      focusSubjects {
        id
        name
      }
      grades {
        id
        name
        value
      }
      programme {
        id
        name
      }
      serviceProviders {
        id
        name
      }
      subject {
        id
        name
        subjectGradeReference
      }
      testPerformanceData {
        id
        circuit {
          id
          name
        }
        district {
          id
          name
        }
        emisNumber
        grade {
          id
          value
        }
        averageMark
        level1
        level2
        level3
        level4
        level5
        level6
        level7
        numberAbsent
        numberEnrolled
        numberWrote
        passRate
        possibleAttendance
        subject {
          id
          name
        }
        term
        year
        institution {
          id
          emisNumber
          name
        }
        year
      }
    }
  }
`;
